export function shouldShowSafetyNotice(
  passengers: number,
  luggage: number
): boolean {
  if (passengers <= 4) return false;
  if (passengers === 5 && luggage >= 7) return true;
  if (passengers === 6 && luggage >= 5) return true;
  if (passengers === 7 && luggage > 2) return true;
  return false;
}
